import React from "react";
import { Link } from "react-router-dom";
import { BRANDS } from "@/mock";

/**
 * BrandMarquee - a continuously scrolling bar of the brand logos we carry.
 * Logos loop seamlessly (list duplicated) and the animation pauses on hover.
 */
export default function BrandMarquee() {
  const loop = [...BRANDS, ...BRANDS];
  return (
    <section aria-label="Brands we carry" className="border-y border-neutral-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 pt-6 sm:px-6 lg:px-8">
        <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-neutral-500">
          The Brands We Carry
        </p>
      </div>
      <div className="overflow-hidden py-6">
        <div className="marquee-track flex w-max items-center gap-4">
          {loop.map((b, i) => (
            <Link
              key={`${b.slug}-${i}`}
              to={`/brands/${b.slug}`}
              aria-label={b.name}
              data-testid={`marquee-brand-${b.slug}-${i}`}
              className="flex h-24 w-44 shrink-0 items-center justify-center rounded-xl border border-neutral-200 bg-white px-3 shadow-sm transition-shadow hover:shadow-md focus-visible:ring-2 focus-visible:ring-[#D0021B] sm:h-28 sm:w-56"
            >
              <img
                src={`/brands/mono/${b.slug}.png`}
                alt={`${b.name} logo`}
                width="600"
                height="300"
                className="h-full w-full object-contain"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
